import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getAbsherData = createAsyncThunk("api/absher", async (token) => {
    try {
        const response = await nodeinstance.get("/absher", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const AbsherDataSlice = createSlice({
    name: "absher",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAbsherData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getAbsherData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAbsherData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getAbsherData };
export default AbsherDataSlice.reducer;
